export default ctx => action =>
  new Promise(async (resolve, reject) => {
    try {
      const { listId, tableName, recordId } = action.options
      const params = { listId, tableName }

      if (!listId || !!!Number(listId)) throw { message: 'List ID should be positive integer' }
      if (!recordId || !!!Number(recordId)) throw { message: 'Record ID should be positive integer' }
      if (!tableName) throw { message: 'Table Name should not be empty' }

      const { errors } = await ctx.$axios.$delete(`/list/${recordId}`, { params })

      if (!!errors) throw { errors }

      resolve()
    }
    catch (e) {
      console.error('[DELETE_RECORD_IN_TABLE_OF_LIST]: ', e)
      const { errors } = (e.response || {}).data || {}
      let options = { title: 'Error', message: 'Undefined error' }

      if (!errors) {
        if (e.title) options.title = e.title
        if (e.message) options.message = e.message
        ctx.app.$q.dialog(options)
      } else {
        for (const error of errors) {
          if (error.title) options.title = error.title
          if (error.detail) options.message = error.detail
          ctx.app.$q.dialog(options)
        }
      }

      reject()
    }
  })

